// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XBGcy9duUZLDrprgoBpg {}

.g7I2ze9k0hxCLiqDisEa + .g7I2ze9k0hxCLiqDisEa {
    margin-top: 16px;
}

.eeBFyiguEGdlKbIsa_MA {
    border-bottom: 1px solid #ddd;
    padding-bottom: 4px;
    margin-bottom: 8px;
    font-size: 16px;
}

.sYe_UC5uZ6aAAi2P0ilS {
    line-height: 1.5;
    font-size: 13px;
}

.sYe_UC5uZ6aAAi2P0ilS + .sYe_UC5uZ6aAAi2P0ilS {
    margin-top: 6px;
}

.BqKGGAupPBtmo7vzOqb9 {
    font-weight: 600;
    display: block;
}

.h_a8GcRh9A6gloM3yIAw {}

.lE4CKCbsSw3RmZR1pnrW {
    font-style: italic;
    font-weight: 200;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/interests-profile/components/details.module.css"],"names":[],"mappings":"AAAA,uBAAY;;AAEZ;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA,uBAAY;;AAEZ;IACI,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":[".container {}\n\n.group + .group {\n    margin-top: 16px;\n}\n\n.heading {\n    border-bottom: 1px solid #ddd;\n    padding-bottom: 4px;\n    margin-bottom: 8px;\n    font-size: 16px;\n}\n\n.row {\n    line-height: 1.5;\n    font-size: 13px;\n}\n\n.row + .row {\n    margin-top: 6px;\n}\n\n.fieldName {\n    font-weight: 600;\n    display: block;\n}\n\n.fieldData {}\n\n.fieldDataEmpty {\n    font-style: italic;\n    font-weight: 200;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `XBGcy9duUZLDrprgoBpg`,
	"group": `g7I2ze9k0hxCLiqDisEa`,
	"heading": `eeBFyiguEGdlKbIsa_MA`,
	"row": `sYe_UC5uZ6aAAi2P0ilS`,
	"fieldName": `BqKGGAupPBtmo7vzOqb9`,
	"fieldData": `h_a8GcRh9A6gloM3yIAw`,
	"fieldDataEmpty": `lE4CKCbsSw3RmZR1pnrW`
};
export default ___CSS_LOADER_EXPORT___;
